import { useNavigate } from 'react-router-dom';
import { ViewMode } from '../catalog-wrapper';
import { useEffect, useRef, useState } from 'react';
import { SortKey, SortOrder, sortValues } from '../../../catalog';

interface SortRowProps {
    sortBy: SortKey;
    sortOrder: SortOrder;
    onSortChange: (key: SortKey) => void;
    viewMode: ViewMode;
    setViewMode: (mode: ViewMode) => void;
    toggleFilter: () => void;
}

function SortRow({ sortBy, sortOrder, onSortChange, viewMode, setViewMode, toggleFilter }: SortRowProps) {
    const navigate = useNavigate();
    const [showSortDropdown, setShowSortDropdown] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const onSort = (key: SortKey) => {
        onSortChange(key);
        setShowSortDropdown(false);
    };

    useEffect(() => {
        if (showSortDropdown) {
            const callback = (e: MouseEvent) => {
                if (!dropdownRef.current?.contains(e.target as Node)) {
                    setShowSortDropdown(false);
                }
            };
            window.addEventListener('click', callback);
            return () => window.removeEventListener('click', callback);
        }
    }, [showSortDropdown]);
    return (
        <div className="catalog-content__row">
            <button
                onClick={() => navigate(-1)}
                className="ui-button ui-button--outline ui-button--back-arrow"
            >
                <i className="icon-arrow-left" />
            </button>
            <div className="ui-button ui-button--filter" onClick={toggleFilter}>
                <i className="icon-settings" />
                <span className="ui-button__text ui-button__text--desktop">Фильтр по параметрам</span>
                <span className="ui-button__text ui-button__text--mobile">Фильтр</span>
            </div>
            <div
                className="catalog-content__sorting"
                ref={dropdownRef}
                onClick={() => setShowSortDropdown(!showSortDropdown)}
            >
                <div
                    className={
                        'ui-select ui-select--gray ui-select--sorting ui-select--selected' +
                        (showSortDropdown ? ' ui-select--opened' : '')
                    }
                >
                    <input className="ui-select__control" name="sorting" />
                    <div className="ui-select__preview">
                        <div className="ui-select__text">{sortBy && sortValues[sortBy]}</div>
                        <div className="ui-select__icon">
                            <i className="fas fa-chevron-down" />
                        </div>
                    </div>
                    <div className="ui-select__options">
                        {Object.entries(sortValues).map(([key, name]) => (
                            <div
                                key={key}
                                className="ui-select-option"
                                onClick={() => onSort(key as SortKey)}
                            >
                                {name}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="catalog-content-view">
                <div
                    className={
                        'catalog-content-view__item' +
                        (viewMode === ViewMode.Tile ? ' catalog-content-view__item--active' : '')
                    }
                    onClick={() => setViewMode(ViewMode.Tile)}
                    data-view="tile"
                >
                    <i className="icon-tile" />
                </div>
                <div
                    className={
                        'catalog-content-view__item' +
                        (viewMode === ViewMode.List ? ' catalog-content-view__item--active' : '')
                    }
                    onClick={() => setViewMode(ViewMode.List)}
                    data-view="list"
                />
            </div>
        </div>
    );
}

export default SortRow;
